module.exports = __webpack_public_path__ + "static/img/14002002.4a3f377b.png";